// Copyright (c) 2020 Deere & Company

import './index.scss';

import * as busyCounter from '../../shared/action-creator/busy-counter';
import { Link, withRouter } from 'react-router-dom';
import React, { Component } from 'react';
import { createErrorMessage, createSuccessMessage } from '../../shared/action-creator/alert-messages';
import { formatGivenDate, getExcelDownloadFile } from '../../shared/services/common-functions';
import {
    getBeginWeeks, getConstraintKey, getConstraintType, getEndWeeks
} from '../../common/repositories';
import { getOrderConstraintBuildWeek, getOrderConstraintExcel } from './repositories';
import BusyCounterLoadingIndicator from '../../shared/components/busyCounter/busy-counter-loading-indicator';
import CheckOrderConstraintBuildWeekTable from './components/check-orders-constraint-build-week-table';
import OptionsDropDown from '../../shared/components/options-drop-down';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { showLoadingIndicator } from '../../shared/state/busy-counter';

class CheckOrderConstraintBuildWeek extends Component {

    state = {
        types: [],
        keys: [],
        selectedKey: '',
        selectedType: '',
        results: null,
        beginWeeks: [],
        endWeeks: [],
        selectedBeginWeek: '',
        selectedEndWeek: ''
    };

    componentDidMount = () => {

        const query = new URLSearchParams( this.props.location.search );
        const queryConstraintType = query.get( 'constrainttype' );
        const queryConstraintKey = query.get( 'constraintkey' );
        const queryBeginWeek = query.get( 'beginweek' );
        const queryEndWeek = query.get( 'endweek' );
        this.handleQueryParams( queryConstraintType, queryConstraintKey,
            queryBeginWeek, queryEndWeek );

    }

    componentDidUpdate = prevProps => {

        if ( this.props.location.search !== prevProps.location.search ) {

            const query = new URLSearchParams( this.props.location.search );
            const queryConstraintType = query.get( 'constrainttype' );
            const queryConstraintKey = query.get( 'constraintkey' );
            const queryBeginWeek = query.get( 'beginweek' );
            const queryEndWeek = query.get( 'endweek' );
            this.handleQueryParams( queryConstraintType, queryConstraintKey,
                queryBeginWeek, queryEndWeek );
            window.scrollTo( 0, 0 );

        }

    }

    handleQueryParams ( queryConstraintType, queryConstraintKey, queryBeginWeek, queryEndWeek ) {

        if ( ( this.state.selectedType !== '-1' && this.state.selectedKey !== '-1' ) || ( queryConstraintType && queryConstraintKey ) ) {

            this.props.increaseCounter();
            getBeginWeeks( ).then( response => {

                const bWeeks = response.map( i => {

                    const wk = formatGivenDate( i.beginWeek, 'YYYY-MM-DD' );
                    let wkn = wk;
                    if ( wk === '2000-01-01' ) wkn = 'Inventory';
                    if ( wk === '2000-02-01' ) wkn = 'Rework';
                    return { id: wk, value: wkn };

                } );
                this.setState( {
                    beginWeeks: bWeeks
                } );
                if ( queryBeginWeek ) {

                    this.setState( {
                        selectedBeginWeek: queryBeginWeek
                    } );
                    this.props.increaseCounter();
                    getEndWeeks( queryBeginWeek ).then( endWeekResponse => {

                        const eWeeks = endWeekResponse.map( i => {

                            const wk = formatGivenDate( i.endWeek, 'YYYY-MM-DD' );
                            let wkn = wk;
                            if ( wk === '2000-01-01' ) wkn = 'Inventory';
                            if ( wk === '2000-02-01' ) wkn = 'Rework';
                            return { id: wk, value: wkn };

                        } );
                        this.setState( {
                            endWeeks: eWeeks,
                            results: null
                        } );
                        this.props.decreaseCounter();

                    } ).catch( () => {

                        this.props.decreaseCounter();

                    } );

                }
                this.props.decreaseCounter();

            } ).catch( () => {

                this.props.decreaseCounter();

            } );

        }

        this.props.increaseCounter();
        getConstraintType( 'ORDERS_USING_CONSTRAINT', 'regular' ).then( response => {

            this.setState( {
                types: response
            } );
            this.props.decreaseCounter();

            if ( queryConstraintType ) {

                this.setState( {
                    selectedType: queryConstraintType
                }, () => {

                    if ( queryConstraintKey ) {

                        this.props.increaseCounter();
                        getConstraintKey( queryConstraintType ).then( resp => {

                            this.setState( {
                                keys: resp.map( item => ( {
                                    id: item.id.trim(),
                                    value: item.value.trim()
                                } ) ),
                                selectedKey: queryConstraintKey,
                                selectedBeginWeek: queryBeginWeek,
                                selectedEndWeek: queryEndWeek,
                                results: null

                            }, () => {

                                this.refresh();

                            } );
                            this.props.decreaseCounter();

                        } ).catch( () => {

                            this.props.decreaseCounter();

                        } );

                    }

                } );

            }

        } ).catch( () => {

            this.props.decreaseCounter();

        } );

    }

    handleTypeChange ( val ) {

        this.setState( {
            selectedType: val,
            selectedKey: '',
            // selectedKeyObj: null,
            results: null,
            selectedBeginWeek: '',
            selectedEndWeek: ''

        }, () => {

            if ( this.state.selectedType !== '-1' ) {

                this.props.increaseCounter();
                getConstraintKey( val ).then( response => {

                    const keys = response.map( item => ( {
                        id: item.id.trim(),
                        value: item.value.trim()
                    } ) );
                    this.setState( {
                        keys,
                        selectedKey: '',
                        results: null
                    } );
                    this.props.decreaseCounter();

                } ).catch( () => {

                    this.props.decreaseCounter();

                } );

            }

        } );

    }

    handleKeyChange ( val ) {

        this.setState( {
            selectedKey: val,
            // selectedKeyObj: val,
            results: null,
            selectedBeginWeek: '',
            selectedEndWeek: ''
        } );

    }

    handleBeginWeekChange ( val ) {

        this.setState( {
            selectedBeginWeek: val,
            selectedEndWeek: '',
            results: null
        }, () => {

            if ( this.state.selectedBeginWeek !== '-1' ) {

                this.props.increaseCounter();
                getEndWeeks( val ).then( response => {

                    const eWeeks = response.map( i => {

                        const wk = formatGivenDate( i.endWeek, 'YYYY-MM-DD' );
                        let wkn = wk;
                        if ( wk === '2000-01-01' ) wkn = 'Inventory';
                        if ( wk === '2000-02-01' ) wkn = 'Rework';
                        return { id: wk, value: wkn };

                    } );
                    this.setState( {
                        endWeeks: eWeeks,
                        selectedEndWeek: '',
                        results: null
                    } );
                    this.props.decreaseCounter();

                } ).catch( () => {

                    this.props.decreaseCounter();

                } );

            }

        } );

    }

    handleEndWeekChange ( val ) {

        this.setState( {
            selectedEndWeek: val
        }, () => {

            this.refresh();

        } );

    }

    handleCheckOrderConstraintBuildWeek ( constraintType, constraintKey, beginWeek, endWeek ) {

        this.props.increaseCounter();
        getOrderConstraintBuildWeek( constraintType, constraintKey, beginWeek, endWeek )
            .then( response => {

                this.setState( {
                    results: response
                } );

                this.props.decreaseCounter();

            } ).catch( () => {

                this.props.decreaseCounter();

            } );

    }

    handleCheckOrderConstraintExcel ( constraintType, constraintKey, beginWeek, endWeek ) {

        this.props.increaseCounter();
        getOrderConstraintExcel( constraintType, constraintKey, beginWeek, endWeek )
            .then( response => {

                const fileName = `${this.props.unit.name}_${constraintType}_${constraintKey}.xlsx`;

                getExcelDownloadFile( response, fileName );

                this.props.decreaseCounter();

            } ).catch( () => {

                this.props.decreaseCounter();

            } );

    }

    exportToExcel = () => {

        this.handleCheckOrderConstraintExcel( this.state.selectedType, this.state.selectedKey,
            this.state.selectedBeginWeek, this.state.selectedEndWeek );

    }

    refresh () {

        this.handleCheckOrderConstraintBuildWeek( this.state.selectedType, this.state.selectedKey,
            this.state.selectedBeginWeek, this.state.selectedEndWeek );

    }

    render () {

        const {
            selectedKey, selectedType, types, keys, selectedBeginWeek,
            selectedEndWeek, beginWeeks, endWeeks, results
        } = this.state;

        const mapResults = [];
        let k = 1;
        let orderingcodeQty = 0;
        let orders = 0;
        const reportType = results !== null && results !== undefined ? results.reportType : '';
        if ( results !== null && results !== undefined && results.ordersByBWDetails ) {

            for ( let i = 0; i < results.ordersByBWDetails.length; i += 1 ) {

                const resultWithUnitName = results.ordersByBWDetails[i].ordConstraintDetails
                    .map( order => (
                        {
                            ...order,
                            rsd: formatGivenDate( order.rsd, 'YYYY-MM-DD' ),
                            ordEntryDateString: formatGivenDate( order.ordEntryDate, 'YYYY-MM-DD' ),
                            ordBuildWkString: formatGivenDate( order.ordBuildWk, 'YYYY-MM-DD' ),
                            rqstDeliDateString: formatGivenDate( order.rqstDeliDate, 'YYYY-MM-DD' ),
                            ...{ unitName: this.props.unit.name }
                        } ) );
                orders += resultWithUnitName.length;
                let orderQtyforGrid = 0;
                for ( let l = 0; l < resultWithUnitName.length; l += 1 ) {

                    orderingcodeQty += resultWithUnitName[l].ordQnty;
                    orderQtyforGrid += resultWithUnitName[l].ordQnty;

                }
                const totalOrderForGrid = resultWithUnitName.length;
                resultWithUnitName[totalOrderForGrid] = { model: '0', message: `Total Orders: ${totalOrderForGrid} and Total Ordering Quantity: ${orderQtyforGrid}` };
                mapResults[k] = resultWithUnitName;
                mapResults[k].buildWeek = results.ordersByBWDetails[i].buildWeek;
                k += 1;

            }

        }

        return (
            <section className="main-content">
                <BusyCounterLoadingIndicator busyCounter={this.props.busyCounter} />
                {/* <Breadcrumbs crumbs={crumbs} /> */}
                <header>
                    <h2 className="page-header">Check Orders By Constraint Build Weeks</h2>
                </header>

                <main>
                    <section className="section-container">
                        <div className="atp-top-options atp-check-order-by-constraint-build-week-top-options">
                            <div className="select-options">
                                <OptionsDropDown
                                    className="atp-constraint-build-week-select"
                                    label="Type"
                                    isPlaceholderTranslated={true}
                                    onChange={this.handleTypeChange.bind( this )}
                                    optionDisplayAttributes={['value']}
                                    optionKey="id"
                                    options={types}
                                    placeholder="Select Type"
                                    selectedValue={selectedType}
                                />
                                {selectedType && selectedType !== '-1' && (
                                    <OptionsDropDown
                                        className="atp-constraint-build-week-select"
                                        label="Key"
                                        isPlaceholderTranslated={true}
                                        onChange={this.handleKeyChange.bind( this )}
                                        optionDisplayAttributes={['value']}
                                        optionKey="id"
                                        options={keys}
                                        placeholder="Select Key"
                                        selectedValue={selectedKey}
                                    />
                                )}
                                {selectedType && selectedKey && selectedKey !== '-1' && (
                                    <OptionsDropDown
                                        className="atp-constraint-build-week-select"
                                        label="Begin Week"
                                        isPlaceholderTranslated={true}
                                        onChange={this.handleBeginWeekChange.bind( this )}
                                        optionDisplayAttributes={['value']}
                                        optionKey="id"
                                        options={beginWeeks}
                                        placeholder="Select Begin Week"
                                        selectedValue={selectedBeginWeek}
                                    />
                                )}
                                {selectedType && selectedKey && selectedBeginWeek && selectedBeginWeek !== '-1' && (
                                    <OptionsDropDown
                                        className="atp-constraint-build-week-select"
                                        label="End Week"
                                        isPlaceholderTranslated={true}
                                        onChange={this.handleEndWeekChange.bind( this )}
                                        optionDisplayAttributes={['value']}
                                        optionKey="id"
                                        options={endWeeks}
                                        placeholder="Select End Week"
                                        selectedValue={selectedEndWeek}
                                    />
                                )}

                                {selectedType && selectedKey && selectedBeginWeek && selectedEndWeek && <span onClick={this.refresh.bind( this )}><i className="icon fa fa-refresh" /></span>}

                            </div>

                            <div className="export-button">
                                {selectedType && selectedKey && selectedBeginWeek
                                && selectedEndWeek && results !== null && (
                                    <button className="primary-button" type="button" onClick={this.exportToExcel.bind( this )}>
                                        <span> Export to Excel </span>
                                    </button>
                                )}
                            </div>

                        </div>
                        <section className="messagecontainer">
                            { results !== null && reportType === 'Bundle' && ( selectedType === 'BN' || selectedType === 'G' ) && (
                                <div className="displayBuildWkMessage">
                                    <span className="buildWkMsg">Build week is the build week of the constraint, not the build week of the order.</span>
                                    <span>View the <Link to={`/${this.props.unit.name}/constraints/check-attachment-orders-by-build-week?constrainttype=${selectedType}&constraintkey=${selectedKey}&beginweek=${selectedBeginWeek}&endweek=${selectedEndWeek}`}>orders by order build week</Link> report to view by order build week.</span>
                                </div>
                            )}
                            {results !== null && (
                                <div className="displaydate"> Status as of {Date()}</div>
                            ) }
                            {results !== null && (
                                <div className="displayErrorMessage">Total Orders for Time Period: {orders} and Total Ordering Quantity for Time Period: {orderingcodeQty}</div>
                            ) }
                        </section>
                        {results !== null && mapResults !== undefined && mapResults.map( ( item, index ) => (
                            <CheckOrderConstraintBuildWeekTable
                                key={`constraint-week-${item.buildWeek}-${index}`}
                                results={item}
                                buildWeek={item.buildWeek}
                            />
                        ) ) }
                    </section>
                </main>
            </section>
        );

    }

}

const mapStateToProps = state => ( {
    busyCounter: showLoadingIndicator( state.application.busyCounter ),
    unit: state.application.unit,
    accessToken: state.oktaState.oktaState.accessToken
} );

CheckOrderConstraintBuildWeek.displayName = 'CheckOrderConstraintBuildWeek';
CheckOrderConstraintBuildWeek.propTypes = {
    busyCounter: PropTypes.bool.isRequired,
    increaseCounter: PropTypes.func.isRequired,
    decreaseCounter: PropTypes.func.isRequired,
    unit: PropTypes.object,
    location: PropTypes.object
};
const mapDispatchToProps = dispatch => ( {
    increaseCounter: () => dispatch( busyCounter.increaseBusyCounter() ),
    decreaseCounter: () => dispatch( busyCounter.decreaseBusyCounter() ),
    createSuccessMessage: message => dispatch( createSuccessMessage( message ) ),
    createErrorMessage: message => dispatch( createErrorMessage( message ) )
} );
export default connect(
    mapStateToProps, mapDispatchToProps
)( withRouter( CheckOrderConstraintBuildWeek ) );
